import { useState } from "react";
import { MapPin, ExternalLink } from "lucide-react";
import { useLang } from "@/i18n";
import privacy from "@/data/privacy.json";

const QUERY = "Via Fratelli Bianchin 13, 31038 Postioma di Paese TV, Italia";
const EMBED = `https://maps.google.com/maps?q=${encodeURIComponent(QUERY)}&z=16&output=embed`;
const OPEN = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(QUERY)}`;
const KEY = "pp-map-ok";

// Google Maps sets third-party cookies, so the iframe only loads once the
// visitor asks for it. The consent lasts for this visit only: sessionStorage
// is cleared when the tab/browser is closed, so the next visit asks again.
const MapEmbed = ({ title, address }) => {
  const { lang } = useLang();
  const m = privacy[lang].mapConsent;
  const [ok, setOk] = useState(() => {
    localStorage.removeItem(KEY); // consent saved by the old version, which never expired
    return sessionStorage.getItem(KEY) === "1";
  });

  if (ok) {
    return <iframe title={title} data-testid="map-iframe" src={EMBED} className="w-full h-[400px] md:h-[480px] border-0" loading="lazy" />;
  }
  return (
    <div className="h-[400px] md:h-[480px] bg-sand flex flex-col items-center justify-center text-center px-6" data-testid="map-consent">
      <MapPin className="h-8 w-8 text-terracotta" aria-hidden="true" />
      <p className="mt-4 font-display text-xl md:text-2xl max-w-lg">{address}</p>
      <p className="mt-3 max-w-md text-sm text-ink/80">{m.text}</p>
      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <button
          type="button"
          data-testid="map-show"
          onClick={() => { sessionStorage.setItem(KEY, "1"); setOk(true); }}
          className="rounded-full bg-terracotta px-7 py-3.5 text-sm font-medium text-cream hover:bg-terracotta-dark transition-colors duration-200 btn-press"
        >
          {m.show}
        </button>
        <a
          href={OPEN}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-7 py-3.5 text-sm font-medium hover:border-terracotta hover:text-terracotta transition-colors duration-200 btn-press"
        >
          {m.open}
          <ExternalLink className="h-4 w-4" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
};

export default MapEmbed;
